
define('text!templates/modules/calendar/animated-session/exercise/history/exercise-history.html',[],function () { return '<div class="history-title">{{#t}}calendar:History{{/t}}</div>\n<div class="alert-no-data"></div>\n<div class="history-list"></div>\n';});

